<script>
    import feedStore from '../stores/feed';
    import Item from "../components/Item/index.svelte";
    import PopupForItemManager from '../components/popups/ManageItem/index.svelte';
    import { getSubscriptionMock } from '../mocks/Mocks.svelte';

    export let subscriptionID;
    let items = [];

    // item manager modal
    let itemManagerModalVisible = false;
    let itemToManage = null;

    function mockGetSubscription() {
        const response = getSubscriptionMock;
        ({ items } = response);
        console.log('get subscription mock response', response);
    }

    function getSubscription() {
        fetch(`/api/v1/subscription/${subscriptionID}`)
        .then(data => data.json())
        .then(response => {
            ({ items } = response);
        });
    }

    function handleLongpress(item) {
        // show a modal
        itemManagerModalVisible = true;
        itemToManage = item;
    }
    const showItemManager = () => {
        itemManagerModalVisible = !itemManagerModalVisible;
    }

    getSubscription();
    // mockGetSubscription();
</script>
<!--  -->
<main>
    {#if itemManagerModalVisible}
            <PopupForItemManager 
                showItemManager={showItemManager}
                item={itemToManage}
                activeFeed={"mySubscription"}
                subscriptions={$feedStore?.subscriptions.map(s => s.subscription) || []}
            />
        {/if}

    {#if items}
        {#each items as item, index (index)}
            <Item
                index={index}
                item={item}
                handleLongpress={handleLongpress}
            />
        {/each}
    {/if}

</main>

<style>
    main {
        max-width: 600px;
        margin: auto;
    }
</style>